import type { Message, MessagePage, ThreadSummary } from '../types';
import { http } from '@/shared/api/httpClient';

export const messagingApi = {
  threads: () => http.get<ThreadSummary[]>('/threads').then((r) => r.data),
  messages: (threadId: string, before?: string) =>
    http.get<MessagePage>(`/threads/${threadId}/messages`, { params: { before, size: 50 } }).then((r) => r.data),
  post: (threadId: string, body: string) => http.post<Message>(`/threads/${threadId}/messages`, { body }).then((r) => r.data),
  markRead: (threadId: string) => http.post(`/threads/${threadId}/read`).then(() => undefined),
  create: (body: { name: string; kind: ThreadSummary['kind']; projectId?: string }) => http.post<ThreadSummary>('/threads', body).then((r) => r.data)
};
